import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'app-mentors',
  templateUrl: './mentors.component.html',
  styleUrls: ['./mentors.component.css']
})
export class MentorsComponent implements OnInit {

  public carouselTile: NgxCarousel;

  constructor() { }

  ngOnInit() {

    this.carouselTile = {
      grid: {xs: 1, sm: 2, md: 4, lg: 5, all: 0},
      slide: 1,
      speed: 400,
      animation: 'lazy',
      point: {
        visible: false
      },
      load: 1,
      touch: true,
      easing: 'ease'
    };
  }


}



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/mentors/mentors.component.ts